import React, { useState } from "react";

const Tabs = ({ children }) => {
  const [active, setActive] = useState(0);

  const changeTab = (event, tab) => {
    event.preventDefault();
    if (tab !== active) {
      setActive(tab);
    }
  };

  return (
    <>
      <ul className="nav nav-pills">
        {children.map((c, i) => {
          return (
            <li className="nav-item" key={i}>
              <a
                href="#"
                className={"nav-link " + (i === active ? "active" : "")}
                onClick={(event) => changeTab(event, i)}
              >
                {c.props.label}
              </a>
            </li>
          );
        })}
      </ul>
      <div className="tab-content mt-5">{children[active].props.children}</div>
    </>
  );
};

export default Tabs;
